import { render, staticRenderFns } from "./DashList.vue?vue&type=template&id=7dfdbed6"
import script from "./DashList.vue?vue&type=script&lang=js"
export * from "./DashList.vue?vue&type=script&lang=js"
import style0 from "./DashList.vue?vue&type=style&index=0&id=7dfdbed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports